import { Pipe, PipeTransform } from '@angular/core';

import { PERIMETER_UNITS } from '@core/api';

import { convertPerimeterTo } from '../services/perimeter-converter.service';

@Pipe({ name: 'laPerimeter' })
export class PerimeterPipe implements PipeTransform {
  transform(value: string | number | null, unit: PERIMETER_UNITS = 'm', decimalPlaces = 2, showUnit = true): string | number | null {
    const parsedInput = this.parseInput(value);
    return parsedInput !== null ? convertPerimeterTo(parsedInput, unit, decimalPlaces, showUnit) : value;
  }

  private parseInput(value: string | number | null): number | null {
    if (value === null) {
      return null;
    }

    if (typeof value === 'number') {
      return value;
    }

    const parsedFloat = parseFloat(value);
    if (!isNaN(parsedFloat)) {
      return parsedFloat;
    }

    return null;
  }
}
